/*
 * Only one answer open at a time.
 *
 * The native `name` attribute on <details> does this for free, but the theme's
 * accordion-disclosure element tracks its own open state and animates the
 * transition. When the browser closed a sibling behind its back that state went
 * stale, so the next click on it only re-synced and it took two clicks to
 * reopen. Closing siblings through the element's own `open` setter keeps the
 * custom element in step.
 */
class JsHomeFaq extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('details'));
    if (this.items.length < 2) return;

    this.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (!summary) return;
      const details = summary.closest('details');
      if (!details || !this.items.includes(details)) return;

      // The disclosure element handles its own toggle first; read the result.
      requestAnimationFrame(() => {
        if (!details.open) return;
        for (const other of this.items) {
          if (other !== details && other.open) other.open = false;
        }
      });
    });
  }
}

if (!customElements.get('js-home-faq')) {
  customElements.define('js-home-faq', JsHomeFaq);
}
